<template>
  <div class="slider__holder">
    <p class="slider__title">{{ value }}</p>
    <vue-slider
      ref="slider"
      v-model="value"
      v-bind="options"
      @callback="sliderSetRealValue"
    />
    <span class="slider__start">$0</span>
    <span class="slider__end">$2M</span>
  </div>
</template>
<script>
import vueSlider from 'vue-slider-component'
export default {
  components: {
    vueSlider
  },
  props: {
    'propVal': {
      type: Number,
      default: 275000
    }
  },
  data () {
    return {
      value: '$270,001 - $280,000',
      options: {
        eventType: 'auto',
        width: 'auto',
        height: 14,
        dotSize: 30,
        dotHeight: null,
        dotWidth: null,
        min: 1,
        max: 77,
        interval: 1,
        tooltip: false,
        data: [
          'Under $125,000',
          '$125,001 - $130,000',
          '$130,001 - $135,000',
          '$135,001 - $140,000',
          '$140,001 - $145,000',
          '$145,001 - $150,000',
          '$150,001 - $155,000',
          '$155,001 - $160,000',
          '$160,001 - $165,000',
          '$165,001 - $170,000',
          '$170,001 - $175,000',
          '$175,001 - $180,000',
          '$180,001 - $185,000',
          '$185,001 - $190,000',
          '$190,001 - $195,000',
          '$195,001 - $200,000',
          '$200,001 - $210,000',
          '$210,001 - $220,000',
          '$220,001 - $230,000',
          '$230,001 - $240,000',
          '$240,001 - $250,000',
          '$250,001 - $260,000',
          '$260,001 - $270,000',
          '$270,001 - $280,000',
          '$280,001 - $290,000',
          '$290,001 - $300,000',
          '$300,001 - $310,000',
          '$310,001 - $320,000',
          '$320,001 - $330,000',
          '$330,001 - $340,000',
          '$340,001 - $350,000',
          '$350,001 - $360,000',
          '$360,001 - $370,000',
          '$370,001 - $380,000',
          '$380,001 - $390,000',
          '$390,001 - $400,000',
          '$400,001 - $420,000',
          '$420,001 - $440,000',
          '$440,001 - $460,000',
          '$460,001 - $480,000',
          '$480,001 - $500,000',
          '$500,001 - $520,000',
          '$520,001 - $540,000',
          '$540,001 - $560,000',
          '$560,001 - $580,000',
          '$580,001 - $600,000',
          '$600,001 - $620,000',
          '$620,001 - $640,000',
          '$640,001 - $660,000',
          '$660,001 - $680,000',
          '$680,001 - $700,000',
          '$700,001 - $720,000',
          '$720,001 - $740,000',
          '$740,001 - $760,000',
          '$760,001 - $780,000',
          '$780,001 - $800,000',
          '$800,001 - $820,000',
          '$820,001 - $840,000',
          '$840,001 - $860,000',
          '$860,001 - $880,000',
          '$880,001 - $900,000',
          '$900,001 - $920,000',
          '$920,001 - $940,000',
          '$940,001 - $960,000',
          '$960,001 - $980,000',
          '$980,001 - $1,000,000',
          '$1,000,001 - $1,100,000',
          '$1,100,001 - $1,200,000',
          '$1,200,001 - $1,300,000',
          '$1,300,001 - $1,400,000',
          '$1,400,001 - $1,500,000',
          '$1,500,001 - $1,600,000',
          '$1,600,001 - $1,700,000',
          '$1,700,001 - $1,800,000',
          '$1,800,001 - $1,900,000',
          '$1,900,001 - $2,000,000',
          'Over $2 million'
        ]
      },
      propertyValueVals: [
        125000,
        127500,
        132500,
        137500,
        142500,
        147500,
        152500,
        157500,
        162500,
        167500,
        172500,
        177500,
        182500,
        187500,
        192500,
        197500,
        205000,
        215000,
        225000,
        235000,
        245000,
        255000,
        265000,
        275000,
        285000,
        295000,
        305000,
        315000,
        325000,
        335000,
        345000,
        355000,
        365000,
        375000,
        385000,
        395000,
        410000,
        430000,
        450000,
        470000,
        490000,
        510000,
        530000,
        550000,
        570000,
        590000,
        610000,
        630000,
        650000,
        670000,
        690000,
        710000,
        730000,
        750000,
        770000,
        790000,
        810000,
        830000,
        850000,
        870000,
        890000,
        910000,
        930000,
        950000,
        970000,
        990000,
        1050000,
        1150000,
        1250000,
        1350000,
        1450000,
        1550000,
        1650000,
        1750000,
        1850000,
        1950000,
        2000001
      ]
    }
  },
  created () {
    this.value = this.options.data[this.propertyValueVals.indexOf(this.propVal)]
  },
  mounted () {
    const preselectIndex = this.options.data.indexOf(this.value)
    this.$emit('input', this.propertyValueVals[preselectIndex])
  },
  methods: {
    sliderSetRealValue: function (val) {
      const valueIndex = this.$refs.slider.getIndex()
      this.$emit('input', this.propertyValueVals[valueIndex])
    }
  }
}
</script>
